/* How an SOV looks, shared by the job's own SOV tab (SOVTab.js) and a sub's schedule of values (subs/SubBilling.js,
   Duncan 2026-10-29: "it's got to look similar to what we have for the customer SOV"): a section's dot color and a
   line's category pill. */

/** Stable hash → OKLCH hue for a section name. Mirror of Schedule
 *  helpers so SOV section dots match Schedule section dots when the
 *  same section name appears in both. */
function sovSectionHue(name) {
  let h = 0;
  const s = name || '';
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % 360;
}
export const sovSectionColor = (name) => `oklch(0.55 0.1 ${sovSectionHue(name)})`;

// A line's categories, as the SOV line Properties offers them.
export const SOV_CATEGORIES = ['Labor', 'Material', 'Equipment', 'General Conditions', 'Other'];

// Category color mapping matching Base44 design
export const getCategoryStyle = (category) => {
  switch ((category || '').toLowerCase()) {
    case 'material':
      return { backgroundColor: '#FFF3E0', color: '#E65100', border: '1px solid #FFB74D' };
    case 'labor':
      return { backgroundColor: '#E3F2FD', color: '#1565C0', border: '1px solid #64B5F6' };
    case 'general conditions':
      return { backgroundColor: '#F5F5F5', color: '#616161', border: '1px solid #BDBDBD' };
    case 'equipment':
      return { backgroundColor: '#E8F5E9', color: '#2E7D32', border: '1px solid #81C784' };
    case 'other':
      return { backgroundColor: '#F3E5F5', color: '#6A1B9A', border: '1px solid #BA68C8' };
    default:
      return { backgroundColor: '#F5F5F5', color: '#616161', border: '1px solid #BDBDBD' };
  }
};
